import * as React from 'react';
import * as cost from "./style.module.scss";
import { Modal } from '../../../../Modal';
import { GetCourseWidget } from "../../../../GetCourseWidget";
import { TaxDeduction } from "../../../../TaxDeduction";

export const CostSub = () => {
  const [showModalSub, setShowModalSub] = React.useState(false);
  const [showModalConsult, setShowModalConsult] = React.useState(false);
  return (
    <section className={cost.cost} id="user-action">
      <div className="container">
        <h3>Стоимость курса<br/>«Как научить ребёнка читать быстро и с умом»</h3>
        <div className={cost.cost__blocks}>
          <div className={cost.cost__block}>
            <div className={cost.cost__blockContent}>
              <h4>Месяц обучения</h4>
              <p className={cost.cost__blockPrice}>4 999 <span>₽</span></p>
            </div>
            <div className={cost.cost__blockBuy}>
              <div className={cost.cost__blockOnceTime}>
                <button className={cost.cost__blockButton} onClick={()=>{setShowModalSub(true)}}>
                  Купить курс
                </button>
              </div>
              <div className={cost.cost__blockInstallment}>
                <button className={cost.cost__blockButton} onClick={()=>{setShowModalConsult(true)}}>
                  Получить консультацию менеджера
                </button>
              </div>
            </div>
            <p className={cost.cost__blockUndertext}>Списание проходит автоматически, за сутки до оплаты вы получите
              уведомление.</p>
            <TaxDeduction className={cost.cost__blockUndertext} margin={"30px auto 0"}/>
          </div>
        </div>
      </div>

      <Modal
        open={showModalSub}
        onClose={() => {
          setShowModalSub(false);
        }}
      >
        <GetCourseWidget hash={'8adbab32390d30fc93be4160619b7f2f76419a05'} id={'743544'} />
      </Modal>
      <Modal
        open={showModalConsult}
        onClose={() => {
          setShowModalConsult(false);
        }}
      >
        <GetCourseWidget hash={'b21aec395f0239fe0a2fa3655206b138d2eecb80'} id={'739165'} />
      </Modal>
    </section>
  );
};
